// KPI metadata: descriptions for info tooltips, shared between Analytics and Comparativas.

export interface KpiInfo {
  label: string;
  info: string;
}

export const KPI_INFO: Record<string, KpiInfo> = {
  facturacion: {
    label: 'Volumen de reservas',
    info: 'Lo que pagan los huéspedes: alojamiento + limpieza + extras de las reservas confirmadas (estado "accepted") de todos los pisos que cumplen los filtros, gestión incluida. Es el importe bruto, con IVA en todos los canales (el de Booking, que Hostify trae aparte, se suma), y no descuenta comisiones del canal. No es lo que factura Sereno —en gestión Sereno solo factura su parte al propietario—: eso es «Facturación Sereno». Por defecto se imputa por noche: el importe se reparte entre las noches que caen dentro del periodo (devengo).',
  },
  neto: {
    label: 'Ingresos netos (Hostify)',
    info: 'Subtotal de Hostify menos comisión del canal, tarifa de transacción y reembolsos. Es la métrica equivalente al "Total Revenue" del informe Revenue de Hostify, útil para cuadrar con sus informes.',
  },
  reservas: {
    label: 'Reservas',
    info: 'En modo "Noche": reservas confirmadas con alguna noche dentro del periodo (una estancia que cruza dos meses cuenta en ambos). En modo "Entrada": reservas con check-in dentro del periodo. Se excluyen cancelaciones, inquiries y reservas no confirmadas.',
  },
  noches: {
    label: 'Noches',
    info: 'En modo "Noche": noches de las reservas que caen dentro del periodo (recortadas al mes). En modo "Entrada": total de noches de las reservas con check-in en el periodo.',
  },
  huespedes: {
    label: 'Huéspedes',
    info: 'Suma de huéspedes de las reservas del periodo. En modo "Noche" se prorratea por la fracción de la estancia que cae dentro del periodo, para que una estancia que cruza dos meses no cuente doble.',
  },
  adr: {
    label: 'ADR (precio/noche)',
    info: 'Average Daily Rate. Ingresos de alojamiento (sin limpieza ni extras) divididos entre el total de noches vendidas. Mide el precio medio por noche.',
  },
  estanciaMedia: {
    label: 'Estancia media',
    info: 'Total de noches dividido entre el número de reservas, recortado al periodo seleccionado. Indica la duración media de cada estancia dentro del periodo.',
  },
  ocupacion: {
    label: 'Ocupación',
    info: 'Noches vendidas dividido entre las noches disponibles × 100. Las noches disponibles se calculan con todas las propiedades que cumplen los filtros (activas, zona, selección), incluidas las que no tuvieron reservas en el periodo.',
  },
  comision: {
    label: 'Comisión canal',
    info: 'Suma de la comisión del canal (channel_commission) más la tarifa de transacción (transaction_fee) de las reservas del periodo.',
  },
};
